import type { FetchUserBillingRoutine } from '../interfaces';

export interface PlanState {
  readonly plan: string;
  readonly proratedProfessionalPlanPrice: number;
  readonly proratedAdvisorPlanPrice: number;
  readonly unusedInvestorPlanCredit: number;
  readonly unusedProfessionalPlanCredit: number;
  readonly start: number;
  readonly status: string;
  readonly trialed: boolean;
  readonly canceled: boolean;
  readonly currencyISO: string;
  readonly trialEnd: number;
  readonly trialStart: number;
  readonly currentPeriodEnd: number;
  readonly currentPeriodStart: number;
}

export const getInitialPlanState = (): PlanState => ({
  canceled: false,
  currencyISO: 'USD',
  currentPeriodEnd: 0,
  currentPeriodStart: 0,
  plan: '',
  proratedProfessionalPlanPrice: 0,
  proratedAdvisorPlanPrice: 0,
  unusedInvestorPlanCredit: 0,
  unusedProfessionalPlanCredit: 0,
  start: 0,
  status: '',
  trialEnd: 0,
  trialStart: 0,
  trialed: false,
});

export default function planReducer(
  state: PlanState,
  payload: FetchUserBillingRoutine['success']['data']
): PlanState {
  return {
    ...state,
    plan: payload.plan,
    start: payload.start,
    status: payload.status,
    trialed: payload.trialed,
    currencyISO: payload.currency,
    canceled: payload.canceled,
    trialEnd: payload.trial_end ? payload.trial_end : 0,
    trialStart: payload.trial_start ? payload.trial_start : 0,
    currentPeriodEnd: payload.current_period_end
      ? payload.current_period_end
      : 0,
    currentPeriodStart: payload.current_period_start
      ? payload.current_period_start
      : 0,
  };
}
